<template>
  <div class="vehicleApplyPage" v-if="!this.showLoad">
    <h4 class="title">用车申请信息</h4>
    <div class="applyFrom">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.licensePlateNumber"
          label="车牌号："
          input-align="right"
          readonly
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.brandName"
          label="品牌："
          input-align="right"
          readonly
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="baseData.unitCost"
          label="费用（元/公里）："
          readonly
          input-align="right"
          class="ggInput"
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="baseData.seatingCapacity"
          label="座位数（个）："
          readonly
          input-align="right"
          class="ggInput"
        />
      </van-cell-group>
      <!-- 所属项目 -->
      <van-cell-group class="itemSite baseNone baseSalary moreText">
        <van-field
          v-model="baseData.projectName"
          :required="editType"
          type="textarea"
          label="所属项目："
          :placeholder="editType ? '请选择' : ''"
          @click="checkItemPicker"
          :is-link="editType"
          readonly
          rows="1"
          autosize
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          label="用车开始时间："
          v-model="baseData.startTime"
          class="ggInput"
          readonly
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          label="用车结束时间："
          v-model="baseData.endTime"
          class="ggInput"
          readonly
        />
      </van-cell-group>
      <van-cell-group class="baseNone summaryBox moreText">
        <van-field
          v-model="baseData.destination"
          label="前往地点："
          autosize
          input-align="right"
          readonly
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone summaryBox beizhu">
        <van-field
          v-model="baseData.reason"
          label="用车原因："
          rows="1"
          autosize
          type="textarea"
          input-align="right"
          readonly
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="itemPerson baseNone baseSalary beizhu moreText">
        <van-field
          v-model="baseData.driversName"
          readonly
          type="textarea"
          label="驾驶人员："
          rows="1"
          autosize
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="baseData.returnMileage"
          label="归还时里程（公里）："
          readonly
          input-align="right"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="baseData.actualCost"
          label="实际费用（元）："
          readonly
          input-align="right"
          class="ggInput"
        />
      </van-cell-group>
    </div>
    <!-- 附件 -->
    <!-- 微信的附件 避免和原生交互 -->
    <wx-file-view
      v-if="is_weixn"
      :filesData="baseData"
      :editType="editType"
      class="fileview"
    ></wx-file-view>
    <!-- 原生附件 -->
    <file-view
      v-else
      :filesData="baseData"
      :editType="editType"
      @changeFile="changebaseAnnexes"
      class="fileview"
    ></file-view>
    <p class="fgx"></p>
    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="this.mode != 'add' && baseData.verifyStatus != 'hold'"
    >
      <audit-list
        :applicantData="baseData"
        @changeVerifyType="setVerifyType"
      ></audit-list>
    </div>
    <p class="fgx"></p>
    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="this.mode != 'add' && baseData.verifyStatus != 'hold'"
    >
      <flow-staff :applicantData="baseData"></flow-staff>
      <flow-list :workflowCode="baseData.workflowCode"></flow-list>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";

const fileView = () =>
  import("@/views/materialsModule/vehicle/components/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
const refreshPage = () => import("@/components/common/refreshPage");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const flowStaff = () => import("@/components/common/flowStaff");
export default {
  name: "veicleRetrunDetail", //车辆申请   新增/编辑/查看
  components: {
    refreshPage,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
    fileView,
    wxFileView,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      commonType: "", // 返回当前表单时 新增 ？查看？ 编辑？
      commonId: "", //编辑Id
      mode: "",
      editType: false, //当前表单是否可以编辑-- 默认不可编辑
      baseData: {
        carId: "",
        licensePlateNumber: "",
        brandName: "",
        currentMileage: "",
        returnMileage: "",
        seatingCapacity: "",
        unitCost: "",
        driversId: "",
        driversName: "",
        projectName: "",
        projectId: "",
        destination: "", //目的地
        startTime: "", //出发时间
        endTime: "", //回程时间
        reason: "", //用车原因
        baseAnnexes: [],
      },

      showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(2000, 1, 1),
      checkIndex: "", // 获取证书发放和到期时间
      clineType: getDeviceType(),
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      refreshPage: false, // 网络请求失败时显示
      clientType: getDeviceType(), //手机类型
      addType: false, //防止高频点击
      is_weixn: is_wei(), //是否为微信
    };
  },

  mounted() {
    if (is_wei()) {
      document.title = "用车归还详情";
    }
    this.commonType = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.commonId = this.$route.query.commonId; //申请Id
    this.baseData.carId = this.$route.query.carId; //车辆id
    this.$nextTick(() => {
      if (this.userinfo && this.userinfo.id) {
        this.setShowLoad(false); //将loading状态隐藏
        this.initPage();
      }
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),

    initPage() {
      let _this = this;
      //编辑时条用的详情
      _this.$api.material.vehicleApply
        .detailsUseCar(this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseData = newApi.assign({}, _this.baseData, res.data);
            _this.baseData.projectName == null
              ? ""
              : _this.baseData.projectName;
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //监测附件方法
    changebaseAnnexes(data) {
      this.baseData.baseAnnexes = data;
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        if (this.userinfo && this.userinfo.id) {
          this.setShowLoad(false); //将loading状态隐藏
          this.initPage();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.vehicleApplyPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  > p.fgx {
    width: 100%;
    height: 10px;
    background-color: #f6f6f6;
  }
  .title {
    position: relative;
    padding: 0 16px 0 25px;
    font-size: 15px;
    height: 45px;
    line-height: 45px;
    position: relative;
    color: #2581d6;
    font-weight: 700;
    border-bottom: 1px solid #e0e0e0;
    &:before {
      content: "";
      position: absolute;
      width: 5px;
      height: 21px;
      background: #2581d6;
      top: 12px;
      left: 16px;
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .baseNone::after {
    content: none;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  > .baseSalary {
    .van-cell:not(:last-child)::after {
      content: none;
    }
  }
  .ggInput {
    border-bottom: 1px solid #eee;
  }
  .summaryBox {
    min-height: 45px;
    margin-bottom: 2px;

    .van-cell__title {
      span {
        font-size: 15px;
      }
    }
    .van-cell__value {
      .van-field__control {
        color: #969799;
        font-size: 15px;
      }
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  .dwBox {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
}
</style>